import { FC } from "react";
import { Redeem } from "@mui/icons-material";

import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, type IPonziDeposit, PonziDepositStatus } from "@framework/types";
import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import PonziReceiveRewardABI from "@framework/abis/json/Staking/receiveReward.json";

export interface IPonziRewardButtonProps {
  className?: string;
  disabled?: boolean;
  stake: IPonziDeposit;
  variant?: ListActionVariant;
}

export const PonziRewardButton: FC<IPonziRewardButtonProps> = props => {
  const { className, disabled, stake, variant } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaFn } = useMetamask(async (stake: IPonziDeposit) => {
    return writeContractAsync({
      address: stake.ponziRule!.contract.address as AddressType,
      abi: PonziReceiveRewardABI,
      functionName: "receiveReward",
      args: [stake.externalId, false, false],
    });
  });

  const handleReward = (stake: IPonziDeposit): (() => Promise<any>) => {
    return (): Promise<any> => {
      return metaFn(stake);
    };
  };

  if (stake.ponziDepositStatus !== PonziDepositStatus.ACTIVE) {
    return null;
  }

  return (
    <ListAction
      onClick={handleReward(stake)}
      icon={Redeem}
      message="form.tips.reward"
      className={className}
      dataTestId="StakeRewardButton"
      disabled={disabled}
      variant={variant}
    />
  );
};
